import React, { useState, useEffect } from 'react';
import './App.css';
import { generateRecipe as getRecipeFromAI } from './gemini.js'; // 👈 Import from gemini.js
import Select from 'react-select';
import countries from 'i18n-iso-countries';

function App() {
  const [recipe, setRecipe] = useState("Recipe Name");
  const [ingredients, setIngredients] = useState([]);
  const [instructions, setInstructions] = useState([]);
  const image = ("cookie.jpeg");

  const [dietaryRestrictions, setDietaryRestrictions] = useState("");
  const [allergies, setAllergies] = useState("");
  const [country, setCountry] = useState("");
  const [userIngredients, setUserIngredients] = useState("");
  const [onlyUseTheseIngredients, setOnlyUseTheseIngredients] = useState(false);

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const generateRecipe = async () => {
    setLoading(true);
    setError(null); // Reset error state

    try {
      const result = await getRecipeFromAI(
        dietaryRestrictions,
        allergies,
        country,
        userIngredients,
        onlyUseTheseIngredients
      );

      console.log("API result:", result); // Debugging API response

      setRecipe(result.recipe);
      setIngredients(result.ingredients);
      setInstructions(result.instructions);

      
    } catch (error) {
      setError("Oops! Something went wrong. Please try again.");
      console.error("Error generating recipe:", error);
    } finally {
      setLoading(false);
    }
  };

  const dietaryRestrictionsOptions = [
    { value: 'None', label: 'None' },
    { value: 'Dairy-Free', label: 'Dairy-Free' },
    { value: 'Gluten-Free', label: 'Gluten-Free' },
    { value: 'Halal', label: 'Halal' },
    { value: 'Keto', label: 'Keto' },
    { value: 'Kosher', label: 'Kosher' },
    { value: 'Low-Carb', label: 'Low-Carb' },
    { value: 'Low-Fat', label: 'Low-Fat' },
    { value: 'Paleo', label: 'Paleo' },
    { value: 'Pescatarian', label: 'Pescatarian' },
    { value: 'Sugar-Free', label: 'Sugar-Free' },
    { value: 'Vegan', label: 'Vegan' },
    { value: 'Vegetarian', label: 'Vegetarian' }
  ];

  const allergyOptions = [
    { value: 'None', label: 'None' },
    { value: 'Alcohol', label: 'Alcohol' },
    { value: 'Bananas', label: 'Bananas' },
    { value: 'Celery', label: 'Celery' },
    { value: 'Chocolate', label: 'Chocolate' },
    { value: 'Citrus', label: 'Citrus' },
    { value: 'Coconut', label: 'Coconut' },
    { value: 'Corn', label: 'Corn' },
    { value: 'Dairy', label: 'Dairy' },
    { value: 'Eggs', label: 'Eggs' },
    { value: 'Fish', label: 'Fish' },
    { value: 'Garlic', label: 'Garlic' },
    { value: 'Gluten', label: 'Gluten' },
    { value: 'Legumes', label: 'Legumes' },
    { value: 'Lupin', label: 'Lupin' },
    { value: 'Mollusks', label: 'Mollusks' },
    { value: 'Mustard', label: 'Mustard' },
    { value: 'Nuts', label: 'Nuts' },
    { value: 'Onions', label: 'Onions' },
    { value: 'Peanuts', label: 'Peanuts' },
    { value: 'Pineapple', label: 'Pineapple' },
    { value: 'Sesame', label: 'Sesame' },
    { value: 'Shellfish', label: 'Shellfish' },
    { value: 'Soy', label: 'Soy' },
    { value: 'Strawberries', label: 'Strawberries' },
    { value: 'Wheat', label: 'Wheat' }
  ];

  countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
  countries.getNames = ((originalGetNames) => (lang) => {
    const names = originalGetNames.call(countries, lang);
    return { None: "None", ...names };
  })(countries.getNames);
  
  

  const countryOptions = Object.entries(countries.getNames("en"))
    .map(([code, name]) => ({
      value: name,
      label: name
    }))
    .sort((a, b) => a.label.localeCompare(b.label));

  useEffect(() => {
    if (ingredients.length === 0) {
      setOnlyUseTheseIngredients(false);
    }
  }, [ingredients]);

  return (
    <div className="App">
      <h1>
        <img 
          src={image || "cute ai chef logo.png"} 
          alt="food" 
          onError={(e) => e.target.src = "cute ai chef logo.png"} // fallback in case image fails
        />
      </h1>
      <h2>Put in the specifics and we will generate a recipe for you!</h2>
      <section className="category-section">
        <h3>Any dietary restrictions?</h3>
        <Select
          options={dietaryRestrictionsOptions}
          isMulti
          onChange={selectedOptions =>
            setDietaryRestrictions(selectedOptions.map(option => option.value).join(', '))
          }
        />
        <h3>Any allergies?</h3>
        <Select
          options={allergyOptions}
          isMulti
          onChange={selectedOptions =>
            setAllergies(selectedOptions.map(option => option.value).join(', '))
          }
        />
        <h3>Preferred country or cuisine?</h3>
        <Select
          options={countryOptions}
          isMulti
          onChange={selectedOptions =>
            setCountry(selectedOptions.map(option => option.value).join(', '))
          }
        />
        <h3>Ingredients you have:</h3>
        <input
          type="text"
          placeholder="Enter ingredients (comma separated)"
          onChange={e => setUserIngredients(e.target.value)}
        />
        {userIngredients && <div className='only-use-ingredients'>
          <input 
            type="checkbox" 
            onClick={() => {setOnlyUseTheseIngredients(!onlyUseTheseIngredients)}} 
          /> 
          <p>Do you want to use only these ingredients?</p>
        </div>}
      </section>

      <button onClick={generateRecipe} disabled={loading}>
        {loading ? 'Generating...' : 'Generate'}
      </button>

      {error && <p className="error">{error}</p>}

      <div className="generated-recipe">
        <h2>{recipe}</h2>
        <div className="lists-container">
          <div className="ingredients-section">
            <h2>Ingredients</h2>
            <ul>
              {ingredients.map((ingredient, index) => (
                <li key={index}>{ingredient}</li>
              ))}
            </ul>
          </div>

          <div className="instructions-section">
            <h2>Instructions</h2>
            <ol>
              {instructions.map((instruction, index) => (
                <li key={index}>{instruction}</li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
